const actionTypes = {
  RECEIPT_RESET: 'RECEIPT_RESET',

  RECEIPT_FETCH: 'RECEIPT_FETCH',
  RECEIPT_SUCCESS: 'RECEIPT_SUCCESS',
  RECEIPT_ERROR: 'RECEIPT_ERROR',

  RECEIPT_POSTING_FETCH: 'RECEIPT_POSTING_FETCH',
  RECEIPT_POSTING_SUCCESS: 'RECEIPT_POSTING_SUCCESS',
  RECEIPT_POSTING_ERROR: 'RECEIPT_POSTING_ERROR',

  RECEIPT_CANCELLING_FETCH: 'RECEIPT_CANCELLING_FETCH',
  RECEIPT_CANCELLING_SUCCESS: 'RECEIPT_CANCELLING_SUCCESS',
  RECEIPT_CANCELLING_ERROR: 'RECEIPT_CANCELLING_ERROR',

  RECEIPT_LINES_FETCH: 'RECEIPT_LINES_FETCH',
  RECEIPT_LINES_SUCCESS: 'RECEIPT_LINES_SUCCESS',
  RECEIPT_LINES_ERROR: 'RECEIPT_LINES_ERROR',

  RECEIPT_LINE_ADD_FETCH: 'RECEIPT_LINE_ADD_FETCH',
  RECEIPT_LINE_ADD_SUCCESS: 'RECEIPT_LINE_ADD_SUCCESS',
  RECEIPT_LINE_ADD_ERROR: 'RECEIPT_LINE_ADD_ERROR',

  RECEIPT_LINE_EDIT_FETCH: 'RECEIPT_LINE_EDIT_FETCH',
  RECEIPT_LINE_EDIT_SUCCESS: 'RECEIPT_LINE_EDIT_SUCCESS',
  RECEIPT_LINE_EDIT_ERROR: 'RECEIPT_LINE_EDIT_ERROR',

  RECEIPT_LINE_REMOVE_FETCH: 'RECEIPT_LINE_REMOVE_FETCH',
  RECEIPT_LINE_REMOVE_SUCCESS: 'RECEIPT_LINE_REMOVE_SUCCESS',
  RECEIPT_LINE_REMOVE_ERROR: 'RECEIPT_LINE_REMOVE_ERROR',

  RECEIPT_PRINT_DATA_FETCH: 'RECEIPT_PRINT_DATA_FETCH',
  RECEIPT_PRINT_DATA_SUCCESS: 'RECEIPT_PRINT_DATA_SUCCESS',
  RECEIPT_PRINT_DATA_ERROR: 'RECEIPT_PRINT_DATA_ERROR',

  PRINTER_DATA_FETCH: 'PRINTER_DATA_FETCH',
  PRINTER_DATA_SUCCESS: 'PRINTER_DATA_SUCCESS',
  PRINTER_DATA_ERROR: 'PRINTER_DATA_ERROR',
};

export default actionTypes;
